import React from 'react';
import { getDisplayName } from 'utils/misc';
import { useParams } from 'react-router-dom';

//a HOC component to pass matched url params. Mainly useful in react redux connect. Replaces withRouter HOC as it is being deprecated.
const withRouteParams = (WrappedComponent, displayName = '') => {
  const WithRouteParams = (props) => {
    const routeParams = useParams();
    return <WrappedComponent routeParams={routeParams} {...props} />;
  };
  WithRouteParams.displayName =
    displayName || `WithRouteParams(${getDisplayName(WrappedComponent)})`;
  return WithRouteParams;
};

export default withRouteParams;
